"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopologicalEditorMap = exports.CSS = void 0;
const mithril_component_1 = require("../../components/mithril.component");
const theme_1 = require("../../components/theme");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const topological_editor_map_overlay_1 = require("./topological.editor.map.overlay");
exports.CSS = {
    wrapper: 'c-MapWrapper',
};
const Style = {
    [exports.CSS.wrapper]: {
        height: '100%',
        width: '100%',
    },
};
(0, theme_1.addStyles)(Style);
class TopologicalEditorMap extends mithril_component_1.IMithrilComponent {
    constructor(options) {
        super();
        this.options = options;
        this.map = null;
        this.overlay = null;
        this.name = 'TopologicalEditorMap';
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        services_1.Services.Map.isReadyPromise.then(() => {
            this.map = services_1.Services.Map.map;
            this.map.setMapTypeId('satellite');
            this.map.set('streetViewControl', true);
            this.overlay = new topological_editor_map_overlay_1.TopologicalEditorMapOverlay({
                map: this.map,
                onCollectionClick: (id) => this.options.onTagClick(id),
                onVectorClick: (collectionId, vectorId) => {
                    this.options.onVectorClick(collectionId, vectorId);
                },
                onVectorDragStart: this.options.onVectorDragStart,
                measurementState: this.options.measurementState,
            });
            // Add map click listener if provided
            if (this.options.onMapClick) {
                this.map.addListener('click', (e) => {
                    if (e.latLng) {
                        this.options.onMapClick(e.latLng);
                    }
                });
            }
        });
    }
    onCreate(vnode) {
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'map:create', 'create', 1);
        this.map = services_1.Services.Map.attach(vnode.dom);
    }
    onRemove() {
        if (this.overlay) {
            this.overlay.hide();
            this.overlay.onRemove();
        }
    }
    get nodes() {
        return (0, mithril_1.m)('div', {
            className: exports.CSS.wrapper,
        });
    }
}
exports.TopologicalEditorMap = TopologicalEditorMap;
//# sourceMappingURL=topological.editor.map.js.map